import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil';
import FontAwesome from 'utils/FA';

import { duckify } from "utils/duckify";
import { feeGroups } from '../../ducks';

import FeeEntityDeletionModal from './FeeEntityDeletionModal';
import FeeGroupModal from './FeeGroupModal';
import FeeGroupListItemTable from './FeeGroupListItemTable';

const FeeGroupListItem = ({ data, feeDelete, key }) => {

  const [showDeletionModal, setShowDeletionModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const paymentMethodsTextLen = data.payment_methods.length;
  const paymentMethodsText = data.payment_methods.map((d, index) => {
    const paymentMethod = index < paymentMethodsTextLen - 1 ? d + ' , ' : d;
    return <span key={`paymentMethodType-${index}`}>{paymentMethod}</span>;
  })

  return (
    <div className='fee-group'>
      <div className='fee-group-name'>
        {data.name}
      </div>
      <div className='fee-management-actions'>
        <a className='btn btn-sm btn-primary fee-group-edit' onClick={() => setShowEditModal(true)}>
          <FontAwesome icon={faPencil} />
        </a>
        <a className='btn btn-sm btn-danger fee-group-delete' onClick={() => setShowDeletionModal(true)}>
          <FontAwesome icon={faTrash} />
        </a>
      </div>
      <div>
        <b>Payment Methods: {key}</b>
        <span className="payment-methods-list"> {paymentMethodsText} </span>
      </div>
      <div>
        <span>
          <b>Associated Checklist Item:</b>
          {data.checklist_item &&
            <span className="red"> {data.checklist_item.name}</span>
          }
          {!data.checklist_item &&
            <React.Fragment>
              <span className="red"> None</span>
              <span>- Associate one via the checklist setup page.</span>
            </React.Fragment>
          }
        </span>
      </div>
      <FeeGroupListItemTable
        feeGroupData={data}
      />
      {showDeletionModal &&
        <FeeEntityDeletionModal
          closeModal={() => setShowDeletionModal(false)}
          submitTrigger={() => feeDelete(data.id)}
          deletionMsg='The fee group and all associated fees will be deleted. This action cannot be reversed.'
        />
      }
      {showEditModal &&
        <FeeGroupModal
          closeModal={() => setShowEditModal(false)}
          editData={data}
        />
      }
    </div>
  );
}

const mapDucksToProps = () => ({});
const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
  feeDelete: (feeID) => {
    return dispatch(feeGroups.actions.remove({ id: feeID })).then(() => dispatch(feeGroups.actions.markDirty()));
  }
});

FeeGroupListItem.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    checklist_item: PropTypes.object,
    payment_methods: PropTypes.array
  }),
  feeDelete: PropTypes.func
};

export default duckify(mapDucksToProps, mapStateToProps, mapDispatchToProps)(FeeGroupListItem);
